import classNames from 'classnames';
import React from 'react';
import SubmitButton from '../../../../components/form/SubmitButton';
import { useNamespacedTranslation } from '../../../../hooks/useNamespacedTranslation';

type Props = {
  error?: string;
  disabled?: boolean;
  isEditing?: boolean;
};

const FormButtons: React.FC<React.PropsWithChildren<Props>> = ({
  error,
  disabled,
  isEditing,
}) => {
  const t = useNamespacedTranslation('requestAbsence.form');

  return (
    <>
      {error && <Error>{error}</Error>}
      <SubmitButton disabled={disabled} block>
        {t(isEditing ? 'edit' : 'submit')}
      </SubmitButton>
    </>
  );
};

const Error = ({
  className,
  ...rest
}: React.HtmlHTMLAttributes<HTMLDivElement>) => (
  <div
    className={classNames(
      'd-flex',
      'justify-content-start',
      'w-100',
      'text-danger',
      className,
    )}
    {...rest}
  />
);

export default FormButtons;
